import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { AgreementDetailsBody, AgreementDetailsSection } from '../components'

const propTypes = {
  isLoading: PropTypes.bool,
  name: PropTypes.string,
  portalAgreementStatus: PropTypes.string,
  createdDate: PropTypes.string,
  planNumber: PropTypes.string,
  providerPlanId: PropTypes.string,
  portalAgreementType: PropTypes.string,
  planType: PropTypes.string,
  planStatus: PropTypes.string,
  agreementAudience: PropTypes.string.isRequired,
  planSponsorCompany: PropTypes.shape({
    name: PropTypes.string,
  }),
  planSponsorContact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  displayPlanEinValue: PropTypes.string,
  TPACompany: PropTypes.shape({
    name: PropTypes.string,
  }),
  TPAContact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  consultantCompany: PropTypes.shape({
    name: PropTypes.string,
  }),
  consultantContact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  recordKeeperCompany: PropTypes.shape({
    name: PropTypes.string,
  }),
  recordKeeperContact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  NoDetailsProvidedCard: PropTypes.func.isRequired,
}
const defaultProps = {}

function AgreementDetailsTabContent({
  isLoading,
  name,
  portalAgreementStatus,
  createdDate,
  planNumber,
  providerPlanId,
  portalAgreementType,
  planType,
  planStatus,
  agreementAudience,
  planSponsorCompany,
  planSponsorContact,
  displayPlanEinValue,
  TPACompany,
  TPAContact,
  consultantCompany,
  consultantContact,
  recordKeeperCompany,
  recordKeeperContact,
  NoDetailsProvidedCard,
}) {
  return (
    <>
      {isLoading && <Spinner />}
      <div className="card">
        <div className="header-container">
          <h2>Services agreement details</h2>
        </div>
        <AgreementDetailsBody
          name={name}
          portalAgreementStatus={portalAgreementStatus}
          createdDate={createdDate}
          planNumber={planNumber}
          providerPlanId={providerPlanId}
          portalAgreementType={portalAgreementType}
          planType={planType}
          planStatus={planStatus}
        />
      </div>
      <AgreementDetailsSection
        agreementAudience={agreementAudience}
        planSponsorCompany={planSponsorCompany}
        planSponsorContact={planSponsorContact}
        displayPlanEinValue={displayPlanEinValue}
        TPACompany={TPACompany}
        TPAContact={TPAContact}
        consultantCompany={consultantCompany}
        consultantContact={consultantContact}
        recordKeeperCompany={recordKeeperCompany}
        recordKeeperContact={recordKeeperContact}
        NoDetailsProvidedCard={NoDetailsProvidedCard}
      />
    </>
  )
}

AgreementDetailsTabContent.propTypes = propTypes
AgreementDetailsTabContent.defaultProps = defaultProps

export default AgreementDetailsTabContent
